import { firebaseAuth, initRollbar } from '@mp';
import {
  ConfigurationProvider,
  FirebaseProvider,
  AnalyticsProvider,
  ToastProvider,
} from '@medely/ui-kit';
import App from 'App';
import ErrorBoundary from 'core/containers/ErrorBoundary';
import moment from 'moment-timezone';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import config from '@mp/config';

window.moment = moment;

const container = document.getElementById('root');
const root = createRoot(container as Element);

initRollbar({
  accessToken: config.rollbar.postClientItemKey,
  environment:
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_STAGING === 'true'
        ? 'staging'
        : 'production'
      : '',
});

root.render(
  <BrowserRouter>
    <ErrorBoundary>
      <ToastProvider>
        <SnackbarProvider
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          hideIconVariant
          maxSnack={3}
        >
          <QueryParamProvider ReactRouterRoute={Route}>
            <AnalyticsProvider writeKey={config.segmentWriteKey as string}>
              {/* @ts-ignore */}
              <ConfigurationProvider configuration={config}>
                <FirebaseProvider auth={firebaseAuth}>
                  <App />
                </FirebaseProvider>
              </ConfigurationProvider>
            </AnalyticsProvider>
          </QueryParamProvider>
        </SnackbarProvider>
      </ToastProvider>
    </ErrorBoundary>
  </BrowserRouter>,
);
